module.exports = __webpack_public_path__ + "static/media/icon-line-activism.043bac5d.svg";